import { Currency } from './enums'

/**
 * Normalize currency to match backend expectations
 * API may return: 'EUR', 'eur', 'euro', 'USD', 'usd', etc.
 * Backend expects: 'Eur' | 'Usd' | 'Gbp' | 'Mad' (Capitalized)
 */
export function normalizeCurrency(currency: unknown): Currency {
  if (!currency) return Currency.Eur // Default fallback

  const currencyStr = String(currency).toLowerCase()

  if (currencyStr === 'eur' || currencyStr === 'euro') return Currency.Eur
  if (currencyStr === 'mad' || currencyStr === 'dirham') return Currency.Mad
  if (currencyStr === 'usd') return Currency.Usd
  if (currencyStr === 'gbp') return Currency.Gbp
  if (currencyStr === 'chf') return Currency.Chf

  // Fallback for unknown currencies
  return Currency.Eur
}
/**
 * Flag 'Yes' / 'No' stocké en texte côté backend (marques, modèles : `status`,
 * `prefer`), parfois avec espaces ou casse variable → booléen.
 */
export function isYesFlag(value: unknown): boolean {
  return value === true || String(value ?? '').trim().toLowerCase() === 'yes'
}

/**
 * Équipement d'une place (`in_board.has_window` / `has_shower` / `has_toilet`) : le
 * backend envoie '1' / '0' / null. Attention, `'0'` est truthy en JS — toujours passer
 * par ce helper plutôt qu'un `v-if` direct.
 */
export function hasAmenity(value: unknown): boolean {
  if (value === true || value === 1) return true
  return ['1', 'true', 'yes'].includes(String(value ?? '').trim().toLowerCase())
}
